import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <>
    <div className='sonuf' >
        
        <p>© 2017–2030 Company Akshatha products Ltd, Inc.</p>
     
      </div>
    </>
  )
}

export default Footer